import angular from "angular";

/*******************************************************************************
 * Component */
/**
 * @ngdoc   component
 * @module  csm.books.com.returnItems
 * @name    csm.books.com.returnItems.component:barcodeSearch
 * @description
 * This component manages an input and button combination to parse an entered
 * barcode, and match it to the `barcodeField` from the `dataprovider`.
 *
 * After a selection has been made, the `onSelect` function will be called,
 * passing a copy of the data object as the parameter.
 *******************************************************************************/
export const barcodeSearchComponent = {
  controller: Controller,
  bindings: {
    dataprovider: '=',
    onSelect: '&',
    btnLabel: '@',
    barcodeField: '@',
    labelField: '@',
    placeholder: '@'
  },
  template:
    '\
    <div style="display:table; width:100%">\
      <span style="display:table-cell; width:100%; padding-right:1em;">\
        <lazy-typeahead id               = "ltItems"\
                        ng-model         = "$ctrl.item"\
                        model-load       = "$model"\
                        dataprovider     = "$ctrl.dataprovider"\
                        label-expression = "$data[$ctrl.labelField]"\
                        lt-on-enter      = "$ctrl.handleBarcode($event)"\
                        page-size        = "10"\
                        placeholder      = "{{$ctrl.placeholder}}"\
                        style="width:100%">\
        </lazy-typeahead>\
      </span>\
      <button style="display:table-cell" type="button" class="btn btn-info" ng-click="$ctrl.handleSearch()" ng-bind="$ctrl.btnLabel"></button>\
    </div>'
}

/*******************************************************************************
 * Controller */
/**
 * Controls the data flow of the component.
 *******************************************************************************/
/* @ngInject */ function Controller($element) {
  /** Self reference. */ var $ctrl = this;

  /** Focus to the input when the component is focused. */
  $element[0].focus = focus;

  /*****************************************************************************
   * focus */
  /**
   * Focuses to the input field.
   *****************************************************************************/
  function focus() {
    document.getElementById('ltItems').focus();
  }

  /*****************************************************************************
   * handleBarcode */
  /**
   * Handles the enter event from the lazy-typeahead. The entered text will be
   * matched to an existing item barcode.
   *****************************************************************************/
  $ctrl.handleBarcode = function ($event) {
    var trimmedBC = angular.isObject($ctrl.item) ? '' : $ctrl.item.trim();

    /*-------------------------------------------*/
    /* No barcode provided, no need to continue. */
    /*-------------------------------------------*/
    if (!trimmedBC.length) return;

    /*---------------------------*/
    /* Find the matched barcode. */
    /*---------------------------*/
    $ctrl.dataprovider.some(function (item) {
      if (item[$ctrl.barcodeField] == trimmedBC) {
        $ctrl.item = item;
        $ctrl.handleSearch();
        return true;
      }
    });

    /*---------------------------------------------------*/
    /* Ensure the barcode is cleared for the next input. */
    /*---------------------------------------------------*/
    $ctrl.item = null;
  };

  /*****************************************************************************
   * handleSearch */
  /**
   * Handles the click event of the search button. Sends the selected item to the
   * calling application, and clears the input for the next use.
   *****************************************************************************/
  $ctrl.handleSearch = function () {
    /*---------------------------------------------------*/
    /* Pass a copy of the selected item to the function. */
    /*---------------------------------------------------*/
    $ctrl.onSelect({ $item: angular.extend({}, $ctrl.item) });

    /*----------------------------------------------------------------*/
    /* Clear the selected item and put focus back on the input field. */
    /*----------------------------------------------------------------*/
    $ctrl.item = null;
    focus();
  };
}
